import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsHikeNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M22.73 28.83l-1.2-1.66h-2.48l1.19 1.65-.01.01zm-11.7-1.27l.33-.34a1.2 1.2 0 011.68 0l.35.35a4.274 4.274 0 003.04 1.26h1.78l-1.2-1.66h-.58a2.64 2.64 0 01-1.88-.77l-.34-.34a2.849 2.849 0 00-4.02 0l-.33.33a2.647 2.647 0 01-1.89.78h-.96L5.8 28.83h2.17a4.307 4.307 0 003.06-1.27z" />
        <path d="M28.84 18.05h-1.92l-8.72-4.64a2.569 2.569 0 01-1.37-2.27V8.35a4.64 4.64 0 00-4.63-4.64 3.068 3.068 0 00-2.76 1.7l-.56 1.11-4.03 2.22a4.976 4.976 0 00-2.47 3.41L.52 21.69a17.318 17.318 0 00-.33 3.36 3.779 3.779 0 003.59 3.77l1.19-1.65H3.96a2.121 2.121 0 01-2.12-2.12c0-.41.02-.81.06-1.22h17.22l-1.2-1.66H2.11l.85-4.36a3.74 3.74 0 011.84-2.55l8.77-4.89V8.48L4 13.82c-.1.06-.2.12-.3.19l.3-1.55a3.3 3.3 0 011.65-2.27l4.47-2.47.79-1.57a1.455 1.455 0 011.29-.79 2.971 2.971 0 012.84 2.1.84.84 0 01.05.17c.06.235.09.477.09.72v9.34l1.56.83 1.83-1.14v2.11l1.48.79 1.93-1.15v2.18l1.34.71 4.07-2.32h1.45a1.338 1.338 0 011.33 1.34 6.137 6.137 0 01-6.13 6.13h-.47l1.17 1.63h.01a7.81 7.81 0 007.08-7.76 3 3 0 00-2.99-2.99zm-12.01-1.54v-2.04a3.3 3.3 0 00.6.4l1.1.59zm3.39 1.75v-1.91l1.69.9zm3.41 1.69v-1.78l1.62.86z" />
      </g>
    </svg>
  )
);
SvgSportsHikeNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsHikeNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsHikeNormalMedium;
